import React from 'react';
import {ValuesMovementType} from '../../types/StoreReportTypes';
import FromDateToDateFilter from './Components/FromDateToDateFilter';
import {Form, Formik} from 'formik';
import RowCheckboxInPopupFilter from './Components/RowCheckboxInPopupFilter';
import LightGreenButton from '../Buttons/LightGreenButton';
import GreenButton from '../Buttons/GreenButton';
import {useTranslation} from 'react-i18next';
import {
	monthNow,
	todayDate,
	getFirstDayOfLastMonth,
} from '../../assets/utils/dateUtils';

type Props = {
	active: boolean;
	handleSubmit: (values: ValuesMovementType) => void;
};
const FilterProducts: React.FC<Props> = ({active, handleSubmit}) => {
	const {t} = useTranslation();
	const initialValues: ValuesMovementType & {
		current_month: boolean;
		last_month: boolean;
	} = {
		from_date: monthNow(),
		to_date: todayDate(),
		every_day: false,
		current_month: false,
		last_month: false,
	};

	return (
		<div
			className={`filter-team__filter-item item-filter ${!active ? '' : 'active'}`}
		>
			<Formik initialValues={initialValues} onSubmit={handleSubmit}>
				{({handleSubmit, resetForm, values, setFieldValue}) => {
					// Обработка изменения чекбоксов
					const handleCheckboxChange = (
						fieldName: string,
						checked: boolean,
					) => {
						if (!checked) return;

						const isCurrentMonth = fieldName === 'current_month';
						const isLastMonth = fieldName === 'last_month';

						if (isCurrentMonth) {
							setFieldValue('last_month', false);
							setFieldValue('from_date', monthNow());
							setFieldValue('to_date', todayDate());
						} else if (isLastMonth) {
							setFieldValue('current_month', false);
							setFieldValue('from_date', getFirstDayOfLastMonth());
							setFieldValue('to_date', monthNow());
						}
					};

					return (
						<Form onSubmit={handleSubmit}>
							<div className="item-filter__wrapper">
								<FromDateToDateFilter
									toDateFieldName={'to_date'}
									byDateFieldName={'from_date'}
								/>
								<RowCheckboxInPopupFilter
									checked={values?.every_day ?? false}
									text={t('По кожному дню')}
									name={'every_day'}
								/>
								<RowCheckboxInPopupFilter
									checked={values?.current_month ?? false}
									text={t('Поточний місяць')}
									name={'current_month'}
									onChange={(checked) =>
										handleCheckboxChange('current_month', checked)
									}
								/>
								<RowCheckboxInPopupFilter
									checked={values?.last_month ?? false}
									text={t('Минулий місяць')}
									name={'last_month'}
									onChange={(checked) =>
										handleCheckboxChange('last_month', checked)
									}
								/>

								<div className="item-filter__buttons">
									<LightGreenButton text={t('Застосувати')} type={'submit'} />
									<GreenButton
										text={t('Очистити')}
										type={'button'}
										onClick={resetForm}
									/>
								</div>
							</div>
						</Form>
					);
				}}
			</Formik>
		</div>
	);
};

export default FilterProducts;
